'use client';

// UI components
import { Button } from '@/components/ui/button';

// Vendors
import { useTranslations } from '@/hooks/useTranslations';
import { Table } from '@tanstack/react-table';

interface ITablePagination<TData> {
  table: Table<TData>;
}

export const Pagination = <TData,>({ table }: ITablePagination<TData>) => {
  const t = useTranslations('Pagination');

  return (
    <div className="flex items-center justify-end space-x-2 py-4">
      <div className="flex-1 text-sm text-muted-foreground">
        {t('rowsShown', {
          shown: table.getRowModel().rows.length,
          total: table.getFilteredRowModel().rows.length,
        })}
      </div>

      <div className="space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
          aria-label="Previous"
        >
          {t('previous')}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
          aria-label="Next"
        >
          {t('next')}
        </Button>
      </div>
    </div>
  );
};
